// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5878":"e92c8b3074b4c0fd","9651":"9be695e992890e60"}[chunkId] + ".js";
};